import { ReactNode } from 'react'

import WhyUs from '../landings/WhyUs'

import { SectionWithPadding } from './styles'

interface AboutUsWhatMakesUsUniqueSectionProps {
  header: string
  tiles: {
    text: ReactNode | string
    title: string
    backgroundColor: string
    icon: ReactNode
  }[]
}
export default function AboutUsWhatMakesUsUniqueSection({
  header,
  tiles
}: AboutUsWhatMakesUsUniqueSectionProps) {
  return (
    <SectionWithPadding $size='large' $tablet $mobile $condensed>
      <WhyUs
        header={header}
        tiles={tiles.map(({ text, title, backgroundColor, icon }) => ({
          text,
          title,
          backgroundColor,
          icon
        }))}
      />
    </SectionWithPadding>
  )
}
